// extracted by mini-css-extract-plugin
export default {"breadcrumb":"Si-z","breadcrumbItem":"Ti-z","hideOnMobile":"Ui-z"};